import { configs } from "../configs";

const { serverUrl } = configs;

/** create a cleaner  request */
export const createCleanerRequest = (requestData) => {
    return fetch (`${serverUrl}/request/create`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData)
    })
}